
export const getTodayDateString = (): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'Europe/London',
  };
  // Using 'sv-SE' locale reliably gives YYYY-MM-DD format.
  return new Date().toLocaleDateString('sv-SE', options);
};
